import helper from 'store/helper';
import types from './types';

const fetchCohort = () => helper.createAction(types.FETCH_COHORT);

const fetchCohortSucceeded = (data) =>
  helper.createAction(types.FETCH_COHORT_SUCCEEDED, data);

const requestStart = () => helper.createAction(types.REQUEST_START);

const requestFailed = (error) =>
  helper.createAction(types.REQUEST_FAILED, { error });

const setCumulativeMode = (cumulativeMode) =>
  helper.createAction(types.SET_CUMULATIVE_MODE, { cumulativeMode });

const setMetric = (metric) =>
  helper.createAction(types.SET_METRIC, { metric });

const setAxis = (axis) => helper.createAction(types.SET_AXIS, { axis });

const hydrateSettings = (payload) =>
  helper.createAction(types.HYDRATE_SETTINGS, payload);

const setFilters = (filters) =>
  helper.createAction(types.SET_FILTERS, { filters });

const downloadCsv = () => helper.createAction(types.DOWNLOAD_CSV);

export default {
  fetchCohort,
  fetchCohortSucceeded,
  requestStart,
  requestFailed,
  setCumulativeMode,
  setMetric,
  setAxis,
  hydrateSettings,
  setFilters,
  downloadCsv,
};
